import ReactDOM from 'react-dom/client';
import { v2Component } from '../../../index';
import { TenantContext } from '../../../context/tenant-context';
import { CustomProductPricingConfigTable } from './custom-product-pricing-config-table';

export function initCustomProductPricingConfig(element?: HTMLElement) {
  const elements = element !== undefined ? [element] : document.getElementsByName('custom-product-pricing-config');

  elements.forEach((element) => {
    if (element.getAttribute('initialized') !== 'true') {
      element.setAttribute('initialized', 'true');
      const root = ReactDOM.createRoot(element);
      const bootstrap = () => {
        const { tenant, contextPath, ...dataset } = Object.assign({}, element.dataset) as any;
        const props = {
          ...dataset,
        };

        root.render(
          v2Component(
            <TenantContext.Provider value={{ tenant, contextPath, spaMode: false }}>
              <CustomProductPricingConfigTable {...props} />
            </TenantContext.Provider>,
          ),
        );
      };
      bootstrap();
    }
  });
}
